var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 100 100",
    fill: "#0d7f81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m69.271 42.085c-5.941-7.138-11.883-14.276-17.824-21.414-0.437-0.524-0.951-0.715-1.447-0.681-0.496-0.034-1.011 0.157-1.447 0.681-5.941 7.137-11.883 14.276-17.824 21.414-1.1 1.319-0.461 3.494 1.446 3.494h7.479v32.386c0 1.116 0.931 2.047 2.047 2.047h16.598c1.116 0 2.047-0.931 2.047-2.047v-32.386h7.479c1.907 0 2.546-2.175 1.446-3.494z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m50 0c-27.614 0-50 22.386-50 50s22.386 50 50 50 50-22.386 50-50-22.386-50-50-50zm0 92c-23.196 0-42-18.805-42-42 0-23.196 18.804-42 42-42 23.195 0 42 18.804 42 42 0 23.195-18.805 42-42 42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5d3b236f8e4500eb9e49a96c4e4003f2.svg";
export { ForwardRef as ReactComponent };